import type { ColorMap } from 'components/DonutChart/types';

export const TEST_ID = 'batteryCard';

export const FULL_PERCENT = 100;

export const AGING_THRESHOLD = 20;

export const CYCLE_LIFE_LOW_THRESHOLD = 0;

export const CYCLE_LIFE_MEDIUM_THRESHOLD = 15;

export const CYCLE_LIFE_HIGH_THRESHOLD = 50;

export const CYCLE_LIFE_COLOR_MAP: ColorMap = {
    [CYCLE_LIFE_HIGH_THRESHOLD]: 'var(--surface-success)',
    [CYCLE_LIFE_LOW_THRESHOLD]: 'var(--surface-alert)',
    [CYCLE_LIFE_MEDIUM_THRESHOLD]: 'var(--surface-warning)'
};
